import React, {PropTypes, Component} from 'react'
import classnames from 'classnames'
import __R from 'containers/__R';

class ClassTeacherListTd extends Component {
  constructor(props){
    super(props)
  }

  static propTypes = {
    classInfo: PropTypes.object.isRequired
  }

  render(){
    let {classInfo} = this.props;
    let {teacherList} = classInfo;

    return(
      <__R can='read_class_teacher'>
        <div className='class-teacher-list'>
          {teacherList.map((teacher) => {
            return(
              <p key={teacher.id}>{teacher.stName}</p>
            )
          })}
        </div>
      </__R>
    )
  }
}

export default ClassTeacherListTd



// WEBPACK FOOTER //
// ./src/containers/pages/Class/ClassTable/ClassTeacherListTd.js